import React from 'react'
import ElementusHero from './presscomponent/hero'
import PressDetail from './presscomponent/pressdetailui'

function Press() {
  return (
    <>
        <div>
            <ElementusHero/>
            <PressDetail/>
        </div>    
    </>
  )
}

export default Press